import Util from "@/helper/Utility.js";

export function DiorPorfileModel() {
    this.isMember = '';
    this.memberCode = '';
    this.bonusPointBalance = '';
    this.expiryDate = '';
    this.memberName = '';
    this.firstName = '';
    this.lastName = '';
    this.mobileNumber = '';
    this.mobileProfileAmend1stDate = '';
    this.redemptionExpiryDate = '';
    this.birthYear = '';
    this.birthMonth = '';
    this.birthDay = '';
    this.email = '';
    this.address = '';
    this.zipcode = '';
    this.province = '';
    this.district = '';
    this.subDistrict = '';
    this.memberType = '';
    this.memberData = '';
    this.originalData = null;
    this.prefix = '';

    this.setDataFormApi = function(data) {
        this.isMember = data.IsMember;
        this.memberCode = data.MemberCode;
        this.bonusPointBalance = data.Profile.Member.BonusPointBalance;
        this.expiryDate = data.Profile.Member.ExpiryDate;
        this.memberName = data.Profile.Member.MemberName;
        var res = this.memberName.split(" ");
        this.firstName = res[0];
        this.lastName = res[1];
        this.mobileNumber = data.Profile.Member.MobileNumber;
        this.mobileProfileAmend1stDate = data.Profile.Member.MobileProfileAmend1stDate;
        this.redemptionExpiryDate = data.Profile.Member.RedemptionExpiryDate;
        this.birthYear = data.Profile.Member.Reference9;
        this.birthMonth = data.Profile.Member.Reference10;
        this.birthDay = data.Profile.Member.Reference11;
        this.email = data.Profile.Member.Reference12;
        this.address = data.Profile.Member.Reference16;
        this.zipcode = data.Profile.Member.Reference17;
        this.province = data.Profile.Member.Reference13;
        this.district = data.Profile.Member.Reference15;
        this.subDistrict = data.Profile.Member.Reference14;
        this.memberType = JSON.parse(data.Profile.Member.Reference20).MemberType;
        this.memberData = JSON.parse(data.Profile.Member.Reference20);

        // this.originalData = data;
    };

    this.setDataFormApiMemberProfile = function(data) {
        this.isMember = true;
        this.memberCode = data.Member.MemberCode;
        this.bonusPointBalance = data.Member.BonusPointBalance;
        this.expiryDate = data.Member.ExpiryDate;
        this.memberName = data.Member.MemberName;
        this.mobileNumber = data.Member.MobileNumber.replace("+66","0").replace(" ","");
        this.mobileProfileAmend1stDate = data.Member.MobileProfileAmend1stDate;
        this.redemptionExpiryDate = data.Member.RedemptionExpiryDate;
        this.prefix = data.Member.Reference8;
        this.birthYear = data.Member.Reference9;
        this.birthMonth = data.Member.Reference10;
        this.birthDay = data.Member.Reference11;
        this.email = data.Member.Reference12;
        this.address = data.Member.Reference16;
        this.zipcode = data.Member.Reference17;
        this.province = data.Member.Reference13;
        this.district = data.Member.Reference15;
        this.subDistrict = data.Member.Reference14;
        this.memberType = JSON.parse(data.Member.Reference20).MemberType;
        let convertJsondata = JSON.parse(data.Member.Reference20);
        let useData = {
            NextLevelAmount: convertJsondata.NextLevelAmount,
            NextLevelFrequency: convertJsondata.NextLevelFrequency,
            NextLevelMemberType: convertJsondata.NextLevelMemberType,
            MembershipPeriodEndDate: convertJsondata.MembershipPeriodEndDate,
        }
        this.memberData = useData;

        // change for support input name with space
        if(convertJsondata){
            this.firstName = convertJsondata.FirstName;
            this.lastName = convertJsondata.LastName;
        }

        // this.memberData = JSON.parse(data.Member.Reference20);
        // this.originalData = data;
    };

    this.getParams = function() {
        // var localeCode = Locale.getLocaleCode();
        var params = {
            memberCode: this.memberCode,
            name: this.firstName,
            surname: this.lastName,
            birthYear: this.birthyear,
            birthMonth: this.birthmonth,
            birthDay: this.birthday,
            email: this.email,
            contactnumber: this.contactNumber,
            address: this.address,
            province: this.province,
            district: this.district,
            subdistrict: this.subDistrict,
            zipcode: this.zipcode,
            prefix: this.prefix,

        };

        params = Util.cleanObjectEmptyStr(params);
        return params;
    };
}
